<template>
  <div class="d-flex flex-column vh-100">
    <form-wizard class="flex-grow-1">    
    </form-wizard>
    <footer class="page-footer font-16">
      <div class="container p-4 text-white" style="width: 630px;">
        <div class="footer-item d-flex align-items-center">
            <span class="icon"><i class="ti-email"></i></span>
            <a href="mailto:info@youroverseashome.com" class="text-word-break ml-2">info@youroverseashome.com</a>
        </div>
        <div class="footer-item d-flex align-items-center">
            <span class="icon"><i class="ti-mobile"></i></span>
            <a href="tel:+442078980541" class="text-word-break ml-2">0808 252 7870</a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Wizard from "@/components/steps/Wizard.vue";

export default {
  name: "Home",
  components: {
    "form-wizard": Wizard
  }
};
</script>
